import styles from './styles.module.scss';
import { Section } from '../../Section';
import { ComponentConfig, DropZone } from '@measured/puck';
import { WithLayout } from '../../Layout';
import getClassNameFactory from '../../commonFunction';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import {
  paddingFields,
  PaddingProps,
} from '../../../puck/reusable-props/padding';
import { marginFields, MarginProps } from '../../../puck/reusable-props/margin';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
} from '../../../utils/helper';
import { ReduxSelectorProps } from '../../../services/constants';
import CustomTooltip from '../../../../components/common/tooltip';
import {
  JustifyContentField,
  JustifyContentProps,
} from '../../../puck/reusable-props/justify-content';
import {
  alignItemsField,
  AlignItemsProps,
} from '../../../puck/reusable-props/align-items';
import { backgroungFields } from '../../../puck/reusable-props/backgroungFields';

const getClassName = getClassNameFactory('Flex', styles);

export type FlexProps = WithLayout<
  {
    direction: 'row' | 'column';
    gap: number;
    wrap: 'wrap' | 'nowrap';
    background: {
      color: string;
      isInherit: boolean;
    };
    border: IBorderValueProps;
  } & MarginProps &
    JustifyContentProps &
    AlignItemsProps &
    showComponentProps &
    PaddingProps
>;

export const FlexInternal = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<FlexProps> => {
  return {
    label: (
      <CustomTooltip title="Flex">
        <span>New Flex</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...paddingFields,
      ...marginFields,
      ...backgroungFields,
      ...JustifyContentField,
      ...alignItemsField,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={onChange}
            title="Border"
            showWidthProps={true}
          />
        ),
      },
      direction: {
        label: 'Direction',
        type: 'radio',
        options: [
          { label: 'Row', value: 'row' },
          { label: 'Column', value: 'column' },
        ],
      },
      gap: {
        label: 'Gap',
        type: 'number',
        min: 0,
      },
      wrap: {
        label: 'Wrap',
        type: 'radio',
        options: [
          { label: 'true', value: 'wrap' },
          { label: 'false', value: 'nowrap' },
        ],
      },
    },
    defaultProps: {
      justifyContent: 'justify-start',
      alignItems: 'items-start',
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      direction: 'row',
      gap: 24,
      wrap: 'wrap',
      layout: {
        grow: true,
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      showComponent: ['desktop', 'tablet', 'mobile'],
      ...borderProps,
    },
    render: ({
      justifyContent,
      direction,
      gap,
      wrap,
      padding,
      margin,
      showComponent,
      border,
      editMode,
      background,
      alignItems,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      return (
        <Section
          style={{
            height: '100%',
            backgroundColor: background?.isInherit
              ? 'inherit'
              : background?.color,
            ...marginStyles,
            ...getBorderProps(border, currentDeviceType, true),
            ...getPaddingStyles(padding, currentDeviceType),
          }}
          className={` ${showComponent?.includes(currentDeviceType) ? '' : '!hidden'}  ${border?.borderStyle?.[currentDeviceType]}`}>
          <DropZone
            key={currentDeviceType}
            className={`${getClassName()}  ${justifyContent} ${alignItems}`}
            style={{
              flexDirection: direction,
              gap,
              flexWrap: wrap,
            }}
            zone="flex"
            disallow={['Hero', 'Stats']}
          />
        </Section>
      );
    },
  };
};
